var _rect, _path, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 28.3556,
    height: 17.8,
    rx: 2.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64522 10.213C8.67579 10.213 9.5022 9.37626 9.5022 8.35598C9.5022 7.33605 8.67614 6.48906 7.64522 6.48906C6.61465 6.48906 5.78823 7.32576 5.78823 8.34605C5.78823 9.36598 6.61429 10.213 7.64522 10.213ZM7.64522 7.06563C8.35231 7.06563 8.92564 7.63895 8.92564 8.34605C8.92564 9.05314 8.35231 9.62647 7.64522 9.62647C6.93763 9.62647 6.3648 9.06258 6.3648 8.35598C6.3648 7.6484 6.93861 7.06563 7.64522 7.06563ZM4.50782 13.0426H10.8025C10.9592 13.0426 11.0908 12.911 11.0908 12.7543C11.0908 11.4757 10.0457 10.4307 8.76714 10.4307H6.54316C5.26455 10.4307 4.21953 11.4757 4.21953 12.7543C4.21953 12.911 4.35113 13.0426 4.50782 13.0426ZM6.54316 11.0072H8.76714C9.63533 11.0072 10.3468 11.6346 10.4862 12.466H4.82408C4.96346 11.6346 5.67497 11.0072 6.54316 11.0072Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.3773,
    y1: 6.25937,
    x2: 24.7329,
    y2: 6.25938,
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.3773,
    y1: 8.37266,
    x2: 24.7329,
    y2: 8.37266,
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.3773,
    y1: 10.482,
    x2: 24.7329,
    y2: 10.482,
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15.3773,
    y1: 12.5953,
    x2: 24.7329,
    y2: 12.5953,
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontId);
export default __webpack_public_path__ + "static/media/front-id.6b5d6e70bc8a0ac0feae47d06be22d4a.svg";
export { ForwardRef as ReactComponent };